import React, { useState } from 'react';
import {
  ADVANCED_MODELS,
  DEEPL_MODELS,
  getDeepLModelType,
  isAdvancedModel,
  setDeepLModelType,
} from '../../constants/deeplModels';
import './deepl-model-picker.css';

/**
 * Chooses which translation engine upcoming translations use.
 *
 * DeepL is the default; the experimental Argos engines sit behind "Advanced".
 * The selection is a local preference read at request time, so engines can be
 * compared by deleting a translation and redoing it with another one.
 */
export default function DeepLModelPicker({ disabled = false }) {
  const [modelType, setModelType] = useState(getDeepLModelType);
  const [showAdvanced, setShowAdvanced] = useState(() => isAdvancedModel(getDeepLModelType()));

  const select = (value) => {
    if (disabled) return;
    setModelType(value);
    setDeepLModelType(value);
  };

  const renderOptions = (models) => (
    <div className="deepl-model-picker__options">
      {models.map((model) => (
        <button
          key={model.value}
          type="button"
          className={`deepl-model${modelType === model.value ? ' is-active' : ''}`}
          onClick={() => select(model.value)}
          disabled={disabled}
          aria-pressed={modelType === model.value}
          title={model.description}
        >
          {model.label}
        </button>
      ))}
    </div>
  );

  return (
    <div className="deepl-model-picker">
      <span className="deepl-model-picker__label">Translation engine</span>
      {renderOptions(DEEPL_MODELS)}
      <button
        type="button"
        className="deepl-model-picker__advanced-toggle"
        onClick={(e) => {
          e.stopPropagation();
          setShowAdvanced((open) => !open);
        }}
        aria-expanded={showAdvanced}
      >
        {showAdvanced ? '▾' : '▸'} Advanced
      </button>
      {showAdvanced && (
        <>
          {renderOptions(ADVANCED_MODELS)}
          <span className="deepl-model-picker__hint">Experimental · English → French only</span>
        </>
      )}
    </div>
  );
}
